var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-teaser',{attrs:{"hit":_vm.hit,"tag-meta-items-overide":_vm.tagMetaItems},scopedSlots:_vm._u([{key:"excerpt",fn:function(){return [_vm._v(" \""+_vm._s(_vm.hit.excerpt)+"\" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }